export default class CalculatorCollapse {
    static init() {
        return new CalculatorCollapse();
    }

    constructor() {
        window.calculatorCollapse = this.calculatorCollapseLogic;
    }

    calculatorCollapseLogic() {
        return {
            currentItemIndex: 0,
            collapseSelectorScroll: 0,
            windowWidth: 0,

            get shouldCenterSelectors() {
                this.windowWidth; // make it reactive
                return this.$refs.collapseTabs?.scrollWidth == this.$refs.collapseTabs?.clientWidth;
            },

            get shouldShowScrollRight() {
                this.windowWidth; // make it reactive
				if (!this.$refs.collapseTabs?.scrollWidth)
					return true;
				return this.collapseSelectorScroll <= this.$refs.collapseTabs?.scrollWidth - this.$refs.collapseTabs?.clientWidth - 5;
            },

            get shouldShowScrollLeft() {
                return this.collapseSelectorScroll > 5;
            },

            handleCollapseScroll: function() {
				this.collapseSelectorScroll = this.$refs.collapseTabs?.scrollLeft;
			},

			scrollLeft: function() {
				this.$refs.collapseTabs.scrollBy({ left: -130, behavior: "smooth" });
			},

			scrollRight: function() {
				this.$refs.collapseTabs.scrollBy({ left: 130, behavior: "smooth" });
			},
        }
    }
}